"use strict";

var buttonsNamesObjectMap = {
  bold: 'bold',
  italic: 'italic',
  underline: 'underline',
  deleted: 'strikethrough',
  unorderedlist: 'unordered list',
  orderedlist: 'ordered list',
  link: 'attach link',
  image: 'attach image'
};
define('rs/form/formobjects/textarea/textarea.formobject.view',['rs/form/formobjects/base.formobject.view', 'redactor', 'rs/models/docstore', 'view/text.editor', 'evisions/redactor.plugins/href.location.redactor.plugin'], function (BaseFormObjectView, Redactor, DocStoreModel, TextEditorView) {
  var TextAreaFormObjectView = BaseFormObjectView.extend({
    templates: {
      'textarea.formobject': 'renderFormControls'
    },
    events: {
      'keydown .redactor_toolbar li': 'handleTextareaEdit'
    },
    renderFormObjectControls: function renderFormObjectControls(templateProperties) {
      return this.renderFormControls(templateProperties);
    },
    handleTextareaEdit: function handleTextareaEdit(event) {
      var link = $(event.target).find('a');
      if ([13, 32].includes(event.keyCode)) {
        link.trigger('click');
      }
    },
    setupFormElement: function setupFormElement() {
      var el = this.getContentElement(),
        delegate = this.getDelegate(),
        doc = delegate.getFormController().getDocumentModel(),
        isPreviewMode = delegate.getFormController().isPreviewMode(),
        textareaEl = null;
      textareaEl = el.find('textarea').html(delegate.getValue());
      if (delegate.isRich() && !this.isDesignerMode()) {
        var options = {
          linebreaks: true,
          minHeight: 200,
          autoresize: true,
          tabFocus: false,
          toolbar: !delegate.isReadOnly(),
          uploadImageUrl: isPreviewMode ? '' : DocStoreModel.getRelativeImageURL(doc.getId()),
          plugins: isPreviewMode ? ['hrefLocation'] : ['hrefLocation', 'imageEmbed'],
          buttons: ['bold', 'italic', 'underline', 'deleted', '|', 'unorderedlist', 'orderedlist', '|', 'link'],
          blurCallback: this.handleTextareaBlur.proxy(this),
          focusCallback: this.handleTextareaFocus.proxy(this)
        };
        if (delegate.isReadOnly()) {
          options.pasteBeforeCallback = function () {
            return this.getSelectionHtml();
          };
        }
        textareaEl.redactor(options);
        if (delegate.isReadOnly()) {
          el.find('.redactor_editor').prop('contenteditable', false);
        }
      }
      delegate.view.$el.find(".redactor_editor").attr("aria-label", delegate.getText().split(/<[^>]*>/).join(''));
      this.setFormElement(textareaEl);
      delegate.view.$el.find('ul').attr("role", "menu");
      delegate.view.$el.find('ul li').each(function (index, item) {
        $(item).attr({
          "tabindex": "0",
          "role": "menuitem"
        });
        Object.keys(buttonsNamesObjectMap).find(function (className) {
          var _$$find$attr;
          if ((_$$find$attr = $(item).find('a').attr('class')) !== null && _$$find$attr !== void 0 && _$$find$attr.includes('re-' + className)) {
            $(item).attr("aria-label", buttonsNamesObjectMap[className] + " button");
            $(item).addClass(className);
          }
        });
      });
    },
    handleTextareaBlur: function handleTextareaBlur() {
      this.getDelegate().requestValueChange();
    },
    handleTextareaFocus: function handleTextareaFocus() {
      this.getDelegate().testSet().ignore();
    },
    getValue: function getValue() {
      var delegate = this.getDelegate();
      if (delegate.isRich()) {
        return this.getFormElement().redactor('get');
      }
      return this.getFormElement().val();
    }
  });
  return TextAreaFormObjectView;
});

